import { newTrack } from '@/track'
import { useHistoryStore } from '@/stores'

export function useFinishedClick() {
  const finishedClick = function (params: {
    elementName: string
    contentId: string
    serialStatus: string
    showNum: number
    title: string
    contentIdRecbook?: string
  }) {
    const historyStore = useHistoryStore()
    const prevPage: any = historyStore.$state.prevPage

    const trackParams: any = {
      element_name: params.elementName,
      contentId: params.contentId,
      serial_status: params.serialStatus,
      show_num: params.showNum,
      title: params.title,
      route_title: prevPage?.route_title || '',
      route_host: prevPage?.route_host || '',
      route_url: prevPage?.route_url || '',
    }

    // 只有书籍点击时才添加 contentId_recbook
    if (params.contentIdRecbook)
      trackParams.contentId_recbook = params.contentIdRecbook

    newTrack('biz_finished_click', trackParams)
  }

  return {
    finishedClick,
  }
}
